import { createContext, useContext } from "react";

type FullscreenOverlayContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  close: () => void;
  show: () => void;
};

export const FullscreenOverlayContext =
  createContext<FullscreenOverlayContextValue | null>(null);

export function useFullscreenOverlay() {
  const context = useContext(FullscreenOverlayContext);

  if (!context) {
    throw new Error(
      "useFullscreenOverlay must be used within FullscreenOverlay",
    );
  }

  return context;
}
